// extracted by mini-css-extract-plugin
export default {"timer":"BonusExparationDate__timer--ig-K3sqk"};